<template>
  <div class="show_all_content_wrapper">
    <main class="no_print">
      <div class="filter_content_wrapper" :class="{ active: filterFormIsActive }">
        <button class="filter_toggler" @click="filterFormIsActive = !filterFormIsActive">
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <base-input col="3" type="text" :placeholder="$t('PLACEHOLDERS.card_code')"
                v-model.trim="filterOptions.card_code" />
              <base-input col="3" type="text" :placeholder="$t('PLACEHOLDERS.serial_number')"
                v-model.trim="filterOptions.serial_number" />

              <base-select-input col="3" :optionsList="isUsedOptions" :placeholder="$t('PLACEHOLDERS.used_status')"
                v-model="filterOptions.is_used" />
              <base-select-input col="3" :optionsList="activeStatuses" :placeholder="$t('PLACEHOLDERS.status')"
                v-model="filterOptions.status" />
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button class="reset_btn" type="button" :disabled="isWaitingRequest" @click="resetFilter">
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.cards") }}</h5>
          <button v-if="!filterFormIsActive" class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive">
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table class="thumb" :loading="loading" :loading-text="$t('TABLES.loadingData')" :search="searchValue"
        :headers="tableHeaders" :items="tableRows" item-class="ltr" :items-per-page="paginations.items_per_page"
        hide-default-footer>
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <template v-slot:[`item.id`]="{ item, index }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id">-</p>
          <p v-else>
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </p>
        </template>

        <template v-slot:[`item.username`]="{ item, index }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.username">
            -
          </p>
          <p v-else>
            {{ item.username }}
          </p>
        </template>

        <template v-slot:[`item.used_status`]="{ item }">
          <v-chip v-if="!item.is_used" color="blue-grey darken-3" text-color="white" small>
            {{ $t("PLACEHOLDERS.new") }}
          </v-chip>
          <v-chip v-else color="blue-grey darken-3" text-color="white" small>
            {{ $t("PLACEHOLDERS.is_used") }}
          </v-chip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <template>
            <span class="text-success text-h5" v-if="item.status">
              <i class="far fa-check"></i>
            </span>
            <span class="text-danger text-h5" v-else>
              <i class="far fa-times"></i>
            </span>
          </template>
        </template>
        <!-- End:: Activation -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom" v-if="!item.status">
              <template slot="title">
                <span>{{ $t("BUTTONS.activate") }}</span>
              </template>
              <span>
                <button :disabled="item.is_used || itemToChange === item.id" class="btn_activate"
                  @click="changeActivationStatus(item)">
                  <i class="fad fa-check-circle fs-5"></i>
                </button>
              </span>
            </a-tooltip>
            <a-tooltip placement="bottom" v-else>
              <template slot="title">
                <span>{{ $t("BUTTONS.deactivate") }}</span>
              </template>
              <span>
                <button :disabled="item.is_used || itemToChange === item.id" class="btn_deactivate"
                  @click="changeActivationStatus(item)">
                  <i class="fad fa-times-circle fs-5"></i>
                </button>
              </span>
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.print") }}</span>
              </template>
              <span>
                <button class="btn_show" @click="printCard(item)">
                  <i class="fad fa-print fs-5"></i>
                </button>
              </span>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>

    <template>
      <div class="pagination_container text-center mt-3 mb-0 no_print">
        <v-pagination class="py-0" square v-model="paginations.current_page" :length="paginations.last_page"
          :total-visible="6" @input="updateRouterQueryParam($event)" :prev-icon="getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
            " :next-icon="getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
              " />
      </div>
    </template>
    <!-- End:: Pagination -->

    <!-- Keep this OUTSIDE the v-data-table, at the root of <template> -->
    <div id="printArea">
      <CardDetails style="display: none;" :item="selectedCard" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardDetails from "../../../components/modals/CardDetails.vue";

export default {
  name: "AllCardCategories",
  components: {
    CardDetails,
  },
  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
    isUsedOptions() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.is_used"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.new"),
          value: 0,
        },
      ];
    },
    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: 0,
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data
      itemToChange: null,
      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        card_code: null,
        serial_number: null,
        is_used: null,
        status: null,
      },

      selectedCard: null, // will hold the card we want to print
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.card_name"),
          value: "card_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.card_code"),
          value: "card_code",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.serial_number"),
          value: "serial_number",
          align: "center",
          width: "80",
          sortable: false,
        },

        {
          text: this.$t("PLACEHOLDERS.client-name"),
          value: "username",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.used_status"),
          value: "used_status",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.status"),
          value: "status",
          align: "center",
          sortable: false,
          width: "120",
        },
        {
          text: this.$t("TABLES.Admins.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Dialogs Control Data
      dialogDelete: false,
      itemToDelete: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data

      // Start:: Page Permissions
      permissions: null,
      // Start:: Page Permissions

      allMainCategories: [],
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/cards/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.card_code = null;
      this.filterOptions.serial_number = null;
      this.filterOptions.status = null;
      this.filterOptions.is_used = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/cards/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "cards",
          params: {
            page: this.paginations.current_page,
            card_code: this.filterOptions.card_code,
            serial_number: this.filterOptions.serial_number,

            is_used: this.filterOptions?.is_used?.value,

            status: this.filterOptions.status?.value,
          },
        });
        this.loading = false;
        this.tableRows = res.data?.data.data;
        this.paginations.last_page = res.data?.data.meta.last_page;
        this.paginations.items_per_page = res.data?.data.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    editItem(item) {
      this.$router.push({ path: `/cards/edit/${item.id}` });
    },
    showItem(item) {
      this.$router.push({ path: `/cards/show/${item.id}` });
    },
    printCard(item) {
      this.selectedCard = item; // pass card to print
      this.$nextTick(() => {
        setTimeout(() => {
          window.print();
        }, 200);
      });
    },
    // ===== End:: Edit

    // ===== Start:: Delete
    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },

    async changeActivationStatus(item) {
      if (item.is_used) return;
      this.itemToChange = item.id;
      try {
        let response = await this.$axios({
          method: "POST",
          url: `cards/toggle/${item.id}`,
        });
        this.setTableRows();
        this.$message.success(response.data.message);
      } catch (error) {
        this.$message.error(error.response.data.message);
      } finally {
        this.itemToChange = null;
      }
    },
    // End:: Change Activation Status
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>
